import React from "react";
import { Button, Image, Popconfirm, Tag, Tooltip } from "antd";
import { Pencil, Trash2 } from "lucide-react";
import { IArtist } from "../../../types/api/artist";

interface GetArtistColumnsParams {
  onEdit: (record: IArtist) => void;
  onDelete: (id: string) => void;
}

export function getArtistColumns({
  onEdit,
  onDelete,
}: GetArtistColumnsParams) {
  return [
    {
      title: "Profile",
      dataIndex: "profilePicture",
      key: "profilePicture",
      width: 64,
      render: (image?: string) => (
        <Image src={image} width={40} height={40} className="rounded-full object-cover" alt="Artist" fallback="https://via.placeholder.com/40" />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: IArtist) => (
        <div>
          <div className="font-medium text-slate-800">{text}</div>
          {record.slug && (
            <div className="text-xs text-slate-400">{record.slug}</div>
          )}
        </div>
      ),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (text: any, record: IArtist) => (
        <div className="text-slate-600">{(record as any).locationName || (typeof text === "string" ? text : null) || "-"}</div>
      ),
    },
    {
      title: "Portal Email",
      dataIndex: "email",
      key: "email",
      render: (email: string) => (
        <div className="text-slate-700 text-xs">{email || <span className="text-slate-400 italic">No email set</span>}</div>
      ),
    },
    {
      title: "Sculptures",
      dataIndex: "productCount",
      key: "productCount",
      width: 100,
      render: (count: number) => (
        <span className={count ? "text-slate-700" : "text-slate-400"}>
          {count || 0}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"}>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 90,
      render: (_: any, record: IArtist) => (
        <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
          <Tooltip title="Edit">
            <Button
              size="small"
              icon={<Pencil size={14} />}
              onClick={() => onEdit(record)}
              className="text-slate-500 hover:text-blue-600 border-none shadow-none bg-transparent"
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              title="Delete this artist?"
              onConfirm={() => onDelete(record._id)}
              okText="Delete"
              okType="danger"
              cancelText="Cancel"
            >
              <Button
                size="small"
                icon={<Trash2 size={14} />}
                className="text-slate-500 hover:text-red-600 border-none shadow-none bg-transparent"
              />
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];
}
